"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var OilCan = function OilCan(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23,12.17a.24.24,0,0,0-.36,0,4.26,4.26,0,0,0-1,1.77,1.16,1.16,0,1,0,2.32,0A4.26,4.26,0,0,0,23,12.17Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.15,9.51l-1-1a.64.64,0,0,0-.78-.09L15.48,12l-1.73-2a.64.64,0,0,0-.48-.22H10.19V8.7h1.49a.64.64,0,0,0,0-1.27H7.43a.64.64,0,0,0,0,1.27H8.92V9.76H6V9.38a.64.64,0, 0,0-.54-.63L1.9,8.2a.63.63,0,0,0-.69.39L0,11.52a.64.64,0,0,0,.41.85l4.26,1.27v2.3a.64.64,0,0,0,.64.64h11a.64.64,0,0,0,.6-.42l1.72-4.64,2.88-1.78.67.67a.64.64,0,0,0, .9-.9ZM1.49,11.34l.72-1.81,2.5.39V12.3Zm14.46,4H6V11h7l1.89,2.22a.64.64,0,0,0,.82.13l1.26-.78Z"
  }));
};

var _default = OilCan;
exports["default"] = _default;